var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80 150C118.66 150 150 118.66 150 80C150 41.3401 118.66 10 80 10C41.3401 10 10 41.3401 10 80C10 118.66 41.3401 150 80 150ZM80 160C124.183 160 160 124.183 160 80C160 35.8172 124.183 0 80 0C35.8172 0 0 35.8172 0 80C0 124.183 35.8172 160 80 160Z",
    fill: "#E3E3E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M114.63 60.1446L108.909 54.382C108.681 54.1273 108.324 54 107.999 54C107.641 54 107.316 54.1273 107.088 54.382L67.4299 93.5103L52.9967 79.3745C52.7367 79.1198 52.4116 78.9924 52.0865 78.9924C51.7615 78.9924 51.4364 79.1198 51.1763 79.3745L45.3901 85.0415C44.87 85.5509 44.87 86.3469 45.3901 86.8563L63.594 104.685C64.7643 105.831 66.1946 106.5 67.3974 106.5C69.1202 106.5 70.6156 105.258 71.1682 104.749H71.2007L114.663 61.9594C115.118 61.4181 115.118 60.6222 114.63 60.1446V60.1446Z",
    fill: "#9046CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.33245e45cf9b46f31c7119c3ab2c830e.svg";
export { ForwardRef as ReactComponent };